import BrowserPersistence from "web/utils/system/storage/storage/browserPersistence";

import DataAbstract from "./dataAbstract";

const storage = new BrowserPersistence();
class DataLocalStorage extends DataAbstract {
  // static TTL = 600000; // 10 * 60 * 1000;
  static TTL = 10000; // 10 * 1000;

  constructor(
    name,
    query,
    endpoint = "/api/magento-catalog/v1/graphql",
    token = "b84a94e8",
    ttl = DataLocalStorage.TTL,
    identifier = "id"
  ) {
    super({ query, ttl, endpoint, token, identifier });
    this.namePrivate = name;
  }

  get name() {
    return this.namePrivate;
  }

  async getItem(key) {
    await null;
    return storage.getItem(this.name, key);
  }

  async setItem(key, value) {
    await null;
    storage.setItem(this.name, key, value, this.ttl);
  }

  async removeItem(key) {
    await null;
    storage.removeItem(this.name, key);
  }

  async clear() {
    await null;
    storage.removeItem(this.name);
  }
}

export default DataLocalStorage;
